const system_limit = {
    limit_exceeded: 'システム上限に達しました。サポートまでお問い合わせください。',
};
export default Object.freeze(system_limit);
